module.exports = __webpack_public_path__ + "img/955f769.svg";